import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { NgRedux, select } from '@angular-redux/store';
import { NotificationService, Notification } from '@ridango/core';

import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
@Component({
    selector: 'ridango-basic-notifications-container',
    templateUrl: './basic-notifications-container.component.html',
    styleUrls: ['./basic-notifications-container.component.scss']
})
export class BasicNotificationsContainerComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() locale: string;
    @select(['core', 'notificationUids']) notificationUids$;
    activeNotifications: Notification[] = [];
    constructor(
        private ngRedux: NgRedux<any>,
        public notifications: NotificationService
    ) {
        super();
    }

    ngOnInit() {
        this.notificationUids$.pipe(takeUntil(this.componentDestroyed$)).subscribe((uids) => {
            this.activeNotifications = [];
            this.activeNotifications = uids.map((uid) => this.ngRedux.getState().core.notifications[uid]);
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
